<template>
  <div
    id="up-nav-sidebar"
    class="bg-primary-500 flex flex-col justify-between pb-5 h-full"
  >
    <div class="mb-1">
      <slot name="appLogo" />
    </div>
    <slot name="sidebarOptions" />
  </div>
</template>
